"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.configureFlex2API = exports.initConfigureFlex2API = exports.useFlex2API = void 0;
var axios_1 = __importDefault(require("axios"));
var axios_hooks_1 = require("axios-hooks");
var mock_adapter_1 = require("./fixtures/mock-adapter");
exports.useFlex2API = (0, axios_hooks_1.makeUseAxios)({
    axios: null
});
var timeout = 15000;
var validateStatus = function (status) {
    return ((status >= 200 && status < 300) ||
        status === 409 ||
        status === 400 ||
        status === 500 ||
        status === 404 ||
        status === 422 ||
        status === 429 ||
        status === 452);
};
var resolveCustomHeaders = function (additionalConfig) {
    var customHeaders = {
        'X-Flex-App-Version': additionalConfig.versionNumber,
        'X-Flex-App-Platform': additionalConfig.platform,
        'X-Flex-App-Device-Id': additionalConfig.deviceId,
        'X-Flex-App-Source': additionalConfig.appSource
    };
    if (additionalConfig.versionName) {
        customHeaders['X-Flex-App-Version-Name'] = additionalConfig.versionName;
    }
    return customHeaders;
};
var initConfigureFlex2API = function (baseUrl, shouldUseMockAdaptor, mockState) {
    var axios = axios_1["default"].create({
        baseURL: baseUrl,
        timeout: timeout,
        validateStatus: validateStatus
    });
    if (shouldUseMockAdaptor) {
        (0, mock_adapter_1.initMocks)(axios, mockState);
    }
    exports.useFlex2API.configure({ axios: axios });
};
exports.initConfigureFlex2API = initConfigureFlex2API;
var configureFlex2API = function (auth, baseUrl, forceRefreshToken, shouldUseMockAdaptor, mockState, additionalConfig) {
    var headers = { 'Content-type': 'application/json' };
    if (additionalConfig) {
        headers = __assign(__assign({}, headers), resolveCustomHeaders(additionalConfig));
    }
    var axios = axios_1["default"].create({
        baseURL: baseUrl,
        timeout: timeout,
        headers: headers,
        validateStatus: validateStatus
    });
    if (shouldUseMockAdaptor) {
        (0, mock_adapter_1.initMocks)(axios, mockState);
    }
    axios.interceptors.request.use(function (config) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = auth().currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken())];
                    case 1:
                        token = _b.sent();
                        if (token) {
                            config.headers.Authorization = "Bearer ".concat(token);
                        }
                        return [2 /*return*/, config];
                }
            });
        });
    });
    axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        var _a;
        var status = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) || 500;
        if (status === 401) {
            return forceRefreshToken().then(function (newToken) {
                error.config.headers['Authorization'] = "Bearer ".concat(newToken);
                return axios_1["default"].request(error.config)["catch"](function (innerError) {
                    var _a;
                    var innerStatus = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) || 500;
                    return Promise.resolve({ status: innerStatus, error: innerError });
                });
            });
        }
        else {
            return Promise.resolve({ status: status, error: error });
        }
    });
    exports.useFlex2API.resetConfigure();
    exports.useFlex2API.configure({ axios: axios, defaultOptions: { autoCancel: false } });
};
exports.configureFlex2API = configureFlex2API;
